// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import historyToDisplay from './criteria';
import report from './report';
import reportIsScrollable from '../../shared/reducers/report-is-scrollable';
import showNoResultsFound from '../../shared/reducers/show-no-results-found';

export const getCombinedReducers = () =>
    combineReducers({
        busyCounter,
        historyToDisplay,
        report,
        reportIsScrollable,
        showNoResultsFound
    });



// WEBPACK FOOTER //
// ./src/reports/labor-rate-history/reducers/index.js